import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Box, Card, CardContent, Divider, Typography } from '@mui/material'
import LogoutButton from '../../components/button/logout-button'

const UserPage: React.FC = () => {
  const { user } = useAuth0()

  return (
    <Card
      variant='outlined'
      sx={{
        // Center card
        position: 'relative',
        margin: 'auto',
        top: '50%',
        transform: 'translateY(-50%)',

        width: 'fit-content',
        padding: 2,
        borderRadius: 0,
      }}
    >
      <CardContent
        sx={{
          height: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ margin: 4 }}>
          <img src={user?.picture} alt='User Picture' style={{ height: '128px' }}/>
        </Box>
        <Typography>
          {user?.name}
        </Typography>
        <Divider flexItem sx={{ marginY: 4 }}/>
        <LogoutButton/>
      </CardContent>
    </Card>
  )
}

export default UserPage
